<template>
    <div>
      <carrier-info :populated-email="accountInfo.accountEmailAddress"
                    ref="form"
                    v-model="carrierInfo"
                    @isComplete="notify" />
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { isNull, isUndefined } from 'lodash-es'

import CarrierInfo from '@/components/CarrierInfo/CarrierInfo'
// import CarrierApi from '@/api-interface/carriers'
import DocumentApi from '@/api-interface/document'
import carrierFileUploads from '@/lookup-data/carrier-file-uploads'
// import wait from '@/helpers/wait'

export default {
  name: 'Registration-CarrierInfo',
  components: {
    CarrierInfo
  },

  props: {
    accountType: {
      default: 'shipper'
    }
  },

  data() {
    return {
      carrierInfo: {}
    }
  },

  async activated() {
    if (this.accountInfo.carrier.carrierKey) {
      const isValid = await this.$refs['form'].validate()

      if (isValid) {
        this.notify(true)
      }
    }
  },

  computed: {
    ...mapGetters('user', { isUserLoggedIn: 'isLoggedIn', accountInfo: 'accountInfo' })
  },

  methods: {
    ...mapActions('user', { updateUserInfo: 'updateDetails' }),

    notify(isFormComplete) {
      this.$emit('canBeSubmitted', isFormComplete)
    },

    async register() {
      const isValid = await this.$refs['form'].validate()

      if (!isValid) {
        this.notify(false)
        return
      }

      const savePayload = { ...this.accountInfo, carrier: this.carrierInfo.carrier }

      try {
        await this.updateUserInfo(savePayload)

        await this.doDocumentUpload()
      } catch (err) {
        debugger
        console.error('Failed to complete carrier registration', err)
      }
    },

    async doDocumentUpload() {
      // will hold the result of each file upload (if there was one)
      const confirmationFlags = {}

      const uploadRequests = []

      carrierFileUploads.forEach((fileInfo) => {
        const file = this.carrierInfo.documents[fileInfo.fieldName]
        if (!isNull(file) && !isUndefined(file)) {
          confirmationFlags[fileInfo.dbFieldName] = null
          const req = DocumentApi.upload(file).then(() => (confirmationFlags[fileInfo.dbFieldName] = true))
          uploadRequests.push(req)
        }
      })

      try {
        await Promise.all(uploadRequests)
      } catch (err) {
        console.error(`Failed to save all files`, err)
      } finally {
        // there is some strange bug on the backend where trying to update the carrier as soon a document is uploaded...
        // ... the changes get eliminated. so this delay is to get around that.
        // await wait(5000)
        // update the carrier account to set the proper flags
        // await CarrierApi.partialUpdate({ carrierId: this.accountInfo.carrier.carrierKey, data: confirmationFlags })
      }
    }
  }
}
</script>

<style scoped>
</style>
